import React, { useCallback, useEffect, useRef, useState } from "react";
import { TradeDetailContainer, TradeDetailListsWrapper } from "./styles";
import TradeActiveTable from "./TradeActiveTable";
import TradeCancelTable from "./TradeCancelTable";
import TradeClosedPnlTable from "./TradeClosedPnlTable";

import TradeDetailHeader from "./TradeDetailHeader";
import TradeFilledTable from "./TradeFilledTable";
import TradeOrderHistoryTable from "./TradeOrderHistoryTable";
import TradePositionsTable from "./TradePositionsTable";
import { useWindowDimensions } from "../../../hooks";
import { useToken } from "@app/hooks";
import { AuthCheckText } from "@app/components";
import TransactionHistory from "../TradeTransaction/TransactionHistory";

const TradeDetail = ({ isResizing, orderBookValue }) => {
  //positions', 'closedpnl', 'active', 'filled', 'orderhistory'
  const [tab, setTab] = useState("positions");
  const [height, setHeight] = useState(340);
  const { data: token } = useToken();
  
  const parentRef = useRef<any>(null);
  const headerRef = useRef<any>(null);

  // 높이 계산 함수
  // TradeDetailListsWrapper의 실제 사용 가능한 높이를 계산
  const calculateHeight = useCallback(() => {
    if (!parentRef.current || !headerRef.current) return;
    
    const parentElement = parentRef.current.parentElement;
    if (!parentElement) return;
    
    const parentHeight = parentElement.clientHeight;
    const headerHeight = headerRef.current.clientHeight;
    const marginTop = Number(parentElement.style.marginTop.replace('px', '') || 0);
    
    // TradeDetailListsWrapper에서 사용할 수 있는 높이
    const availableHeight = parentHeight - headerHeight - marginTop;
    setHeight(availableHeight);
  }, []);

  // 초기 높이 계산
  useEffect(() => {
    const timer = setTimeout(calculateHeight, 0);
    return () => clearTimeout(timer);
  }, [calculateHeight, isResizing]);

  // 부모 요소의 크기 변화 감지
  useEffect(() => {
    if (!parentRef.current?.parentElement) return;

    const resizeObserver = new ResizeObserver((entries) => {
      calculateHeight();
    });

    resizeObserver.observe(parentRef.current.parentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [calculateHeight])
  

  // useEffect(() => {
  //   if (parentRef.current) {
  //     if (parentRef.current?.clientHeight != height) {
  //       setTimeout(() => {
  //         setHeight(parentRef.current?.clientHeight);
  //       }, 100);
  //       setTimeout(() => {
  //         setHeight(parentRef.current?.clientHeight);
  //       }, 500);
  //     }
  //   }
  // }, [w, h, parentRef.current?.clientHeight]);
  
  return (
    <TradeDetailContainer ref={parentRef}>
      {token ? (
        <>
          <TradeDetailHeader tabs={tab} setTabs={setTab} ref={headerRef}/>

          <TradeDetailListsWrapper>
            {tab === "positions" && <TradePositionsTable parentHeight={height} orderBookValue={orderBookValue} />}
            {tab === "positionHistory" && <TradeClosedPnlTable parentHeight={height} />}
            {tab === "openOrders" && <TradeActiveTable parentHeight={height} />}
            {tab === "TradeHistory" && <TradeFilledTable parentHeight={height} />}
            {/*{tab === "cancel" && <TradeCancelTable parentHeight={height} />}*/}
            {tab === "orderhistory" && <TradeOrderHistoryTable parentHeight={height} />}
            {tab === "transactionHistory" && <TransactionHistory parentHeight={height} />}
          </TradeDetailListsWrapper>
        </>
      ) : (
        <AuthCheckText />
      )}
    </TradeDetailContainer>
  );
};

export default React.memo(TradeDetail)
